import { FieldValues, UseFormSetError } from 'react-hook-form';

import { handleErrorForm } from '@services/api';

import {
  CostCenterFilters,
  create,
  linkUser,
  list,
  listAll,
  remove,
  retrieve,
  unlinkUser,
  update,
} from './calls';
import { CostCenter } from 'interfaces/CostCenter';
import { toValueLabel } from 'utils/object';
import { SelectOptions } from 'interfaces/Utils';

export * from './calls';

export default class CostCenterAPICaller {
  static adaptFromAPI = (data: Partial<CostCenter>) => {
    const costCenter = {
      ...data,
    };

    costCenter.department = toValueLabel(data.department as string);

    return costCenter as FieldValues;
  };

  static adaptToAPI = (data: FieldValues) => {
    const costCenter = {
      ...data,
    };

    costCenter.department = (data.department as SelectOptions)?.label;

    return costCenter as CostCenter;
  };

  static list = async (filters: CostCenterFilters) => {
    const {
      data: { costCenters },
    } = await list(filters);

    return {
      ...costCenters,
      result: costCenters.result,
    };
  };

  static listAll = async () => {
    const {
      data: { allCostCenter },
    } = await listAll();

    return {
      ...allCostCenter,
      result: allCostCenter.result,
    };
  };

  static fetch = async (editId: string) => {
    const {
      data: { costCenter },
    } = await retrieve(editId);

    return costCenter;
  };

  static createOrUpdate = async (
    data: FieldValues,
    setError: UseFormSetError<FieldValues>
  ) => {
    const method = data.id ? update : create;

    const result = method(this.adaptToAPI(data)).catch(
      handleErrorForm(setError)
    );

    return result;
  };

  static remove = async (id: string) => {
    const { data } = await remove(id);

    return data;
  };

  static linkUser = async (costCenterId: string, userId: string) => {
    const response = await linkUser(costCenterId, userId);
    return response;
  };

  static unlinkUser = async (costCenterId: string, userId: string) => {
    const response = await unlinkUser(costCenterId, userId);
    return response;
  };
}
